import stefan from '../assets/images/team/stefan-boyd.png';
import addison from '../assets/images/team/addison-muniz.png';
import valentina from '../assets/images/team/valentina-prieto.png';
import armando from '../assets/images/team/armando-ruiz.png';
import alex from '../assets/images/team/alex-bard.png';
import logan from '../assets/images/team/logan-grellmann.jpg';
import allison from '../assets/images/team/allison-good.jpg';
import jonathan from '../assets/images/team/jonathan-hsiung.jpeg';
import usman from '../assets/images/team/usman-bhatti.jpg';
import dalton from '../assets/images/team/dalton-zinn.jpg';

export const content = {
  name: 'The Elevate Team',
  description: `Meet the talented individuals and advisors who drive our vision and mission forward. 
  Their dedication and expertise help ensure our clients' success.`,
};

export const teamMembers = [
  {
    status: 1,
    name: "Stefan Boyd",
    image: stefan,
    role: "Founder & CFO",
    bio: `Formerly from the world of investment banking, Stefan has 10 years of experience as a 
          CFO leading multi-unit concepts such as Le Pain Quotidien, Just Salad, Rosa Mexicano, 
          and Noon Mediterranean. Stefan brings professional CFO assistance to bear on your 
          business including capital raising sourcing and assistance, professional financial 
          reporting, accounting and process oversight, and strategic level partnership.`,
    link: 'https://www.linkedin.com/in/stefan-boyd-a760a74/',
  },
  {
    status: 1,
    name: "Addison Muniz",
    image: addison,
    role: "Controller",
    bio: `Addison is an experienced accounting and finance professional with a background in 
          non-profits, e-commerce, and restaurants. He has held senior roles at Just Salad and 
          Modern Meadow, specializing in financial reporting, audits, and reconciliations. 
          Previously, he worked at Nuts.com and Educational Arts Team. He holds a B.S. in 
          Accounting with a concentration in Management Information Systems from Rutgers Business School.`,
    link: 'https://www.linkedin.com/in/addison-muniz/',
  },
  {
    status: 1,
    name: 'Dalton Zinn',
    image: dalton,
    role: 'Controller',
    bio: `Dalton Zinn is a seasoned professional with over 7 years of experience in the restaurant space. He 
          has held senior positions at The Greene Turtle and Live! Hospitality & Entertainment, specializing in 
          process improvement, system implementation, and financial reporting. Dalton holds a B.S. in Accounting 
          and is a Certified Public Accountant in the state of Maryland.`,
    link: 'https://www.linkedin.com/in/dalton-zinn-cpa-566853145/',
  },
  {
    status: 1,
    name: "Armando Ruiz",
    image: armando,
    role: "Controller",
    bio: `Armando spent the first phase of his career in public accounting working with large 
          companies and hedge funds before moving into the restaurant space, where he has 
          extensive experience. He has served as a Controller over the last 7 years for various 
          restaurant concepts including Mighty Quinn's BBQ and Rosa Mexicano, and has vast 
          experience with restaurant systems, software, and implementation processes.`,
    link: 'https://www.linkedin.com/in/armando-ruiz-mba-ba5a13164/',
  },
  {
    status: 0,
    name: "Valentina Prieto",
    image: valentina,
    role: "Finance Analyst",
    bio: `Valentina is a financial analyst with experience in the restaurant and accounting industries. 
          She has held financial analysis roles at Nobu and Rosa Mexicano, where she managed reporting, 
          cost optimization, and profitability assessments. Previously, she worked as an accountant in Italy, 
          specializing in bookkeeping, tax compliance, and financial statements. She brings expertise in 
          financial reporting, cost control, and data-driven decision-making.`,
    link: 'https://www.linkedin.com/in/valentinaprietomora/',
  },
  {
    status: 1,
    name: "Logan Grellmann",
    image: logan,
    role: "Finance Analyst",
    bio: `Logan is a financial services consultant with experience in risk management, regulatory compliance, 
          and auditing. At Crowe, he works with banks and credit unions to enhance compliance frameworks 
          and mitigate financial risks. He previously held roles at Boston Financial and RSM, gaining 
          expertise in tax and audit. Logan brings a strong background in financial analysis and regulatory 
          consulting.`,
    link: 'https://www.linkedin.com/in/logangrellmann/',
  },
  {
    status: 1,
    name: "Allison Good",
    image: allison,
    role: "Chief Marketing Officer",
    bio: `Allison is a dynamic marketing and branding strategist with over two-decades of experience, including 
          Smith & Wollensky, Quality Branded, Quality Meats, Park Avenue, and Yardbird, among others, leading 
          all aspects of marketing, branding, communications, and strategic partnerships. Prior to that, Allison 
          honed her expertise at top PR firms, including global powerhouse Ketchum and boutique hospitality 
          agency Baltz & Co.`,
    link: 'https://www.linkedin.com/in/adgood/',
  },
  {
    status: 1,
    name: "Alex Bard",
    image: alex,
    role: "IT Systems",
    bio: `Alex is an experienced IT and systems engineer who played a key role in building and optimizing 
          technology infrastructure at Just Salad. He developed in-house ordering systems, enhanced operational 
          efficiency, and led IT initiatives to support the company’s growth. With expertise in system 
          architecture, automation, and infrastructure management, Alex focuses on designing scalable 
          solutions for business operations.`,
    link: 'https://www.linkedin.com/in/alex-bard/',
  },
  {
    status: 1,
    name: "Usman Bhatti",
    image: usman,
    role: "Director of Operations",
    bio: `Usman is an experienced operations and project manager with over 14 plus years of hands-on 
          experience in every phase of the restaurant industry. He has spent time at some fast casual 
          giants like Chipotle and Sweetgreen, as well as extensive time as senior leadership in restaurant 
          startups (Zuul, Popchew, CloudKitchens) focused on the future of food. He specializes in turning 
          ideas into thriving operations, combining big-picture strategy with knowledge of day-to-day restaurant 
          dynamics. He brings a practical, creative, and people-first approach to every project.`,
    link: 'https://www.linkedin.com/in/ubhatti93/',
  },
  {
    status: 1,
    name: 'Jonathan Hsiung',
    image: jonathan,
    role: 'Director of Supply Chain',
    bio: `Jonathan is an expert in hospitality management. During the first phase of his career, he opened and 
          managed full service and luxury hotels within the Ritz-Carlton and Renaissance Hotels brands. Tying the 
          second phase of his career, focused in Operations and Supply Chain, he brings his expertise in vendor 
          management, cost management, logistics, procurement, and scalability.`,
    link: 'https://www.linkedin.com/in/jonathanhsiung/',
  },
];
